export default __webpack_public_path__ + "static/media/bg-Hex-Gradient-Hub.bb5bbd86.jpg";